// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
    },
    selector: {
        products: '#product-loop'
    }
};
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
console.log('Money format');
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

var bcSfFilterTemplate = {
    'saleLabelHtml': '<div class="sale-item icn custom-filter-prod">' + bcSfFilterConfig.label.sale + '</div>',
    'soldOutLabelHtml': '<div class="so icn">' + bcSfFilterConfig.label.sold_out + '</div>',
    'newLabelHtml': '<div class="new icn">' + bcSfFilterConfig.label.new + '</div>',
    'vendorHtml': '<h4>{{itemVendorLabel}}<h4>',
    'quickViewHtml': '<a class="fancybox.ajax product-modal" href="{{itemUrl}}?view=quick">' + bcSfFilterConfig.label.quick_view + '</a>',

    'productGridItemHtml':  '<div id="product-listing-{{itemId}}" class="product-index {{itemGridWidthClass}} tablet-half mobile-half test66" data-alpha="{{itemTitle}}" data-price="{{itemPriceNumber}}">' +
                                '<div class="product-index-inner"><div class="sale-item icn limited-edition" style="display:none">{{limited}}</div><div class="create-at" style="display:none">{{createat}}</div>' +
                                    '{{itemNewLabel}}' +
                                    '{{itemSaleLabel}}' +
                                    '{{itemSoldoutLabel}}' +
                                '</div>' +
                                '<div class="prod-image">' +
                                    '<a href="{{itemUrl}}" title="{{itemTitle}}">' +
                                        '<div class="reveal">' +
                                            '{{itemThumb}}' +
                                            '{{itemFlipImage}}' +
                                        '</div>' +
                                    '</a>' +
                                    '<div class="check-wrap-cross" svg-productid="{{itemId}}">'  
                                       + '<svg class="checkmark_svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">'
                                             + '<circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />'
                                             + '<path class="checkmark__check" fill="none" d="M16 16 36 36 M36 16 16 36" />'
                                        +'</svg>'
                                      +'<span>Out of Stock</span>'
                                     +'</div>'
                                      +'<div class="check-wrap" svg-productid="{{itemId}}">'  
                                       +' <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">'
                                            +'<circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none" />'
                                            +'<path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />'
                                       +'</svg>'
                                      +'<span>Added to Cart</span>'
                                     +'</div>'
                                      +'<form class="product-form" action="/cart/add" data-productid="{{itemId}}"  method="post">' 
                                           +' <div class="product-options">'
                                             + '<h5 class="h-size">Size</h5>'    
                                              +'{{additemSize}}'
                                            +'</div>'
                                            +'<input type="hidden" name="id" data-productid="{{itemId}}" class="product-select" value="" data-variant-title="S" />'
                                            +'<input type="hidden" name="quantity" value="1">'
                                         +'<input name="option-0" type="hidden" value="" class="custom-add-radio">'
                                         +'<a style="display:none;" href="javascript:;" class="listadd" >Add To Cart</a>'
                                        +'</form>' +
                                '</div>' +
                                '<div class="product-info">' +
                                    '<div class="product-info-inner">' +
                                        '<a href="{{itemUrl}}">' +
                                            '{{itemVendor}}' +
                                            '<span class="prod-title">{{itemTitle}}</span>' +
                                        '</a>' +
  										'<div class="price" style="margin-bottom:0px;">{{itemPrice}}</div>' + 
										 '{{looxReviews}}'+
                                         '{{itemSwatch}}' +
                                    '</div>' +
                                '</div>' +
                            '</div>',

    // Pagination Template
    'previousHtml': '<div class="pagiprev"><a href="{{itemUrl}}" title=""><i class="fa fa-caret-left"></i></a></div>',
    'nextHtml': '<div class="paginext"><a href="{{itemUrl}}" title=""><i class="fa fa-caret-right"></i></a></div>',
    'pageItemHtml': '<a href="{{itemUrl}}" title="">{{itemTitle}}</a>',
    'pageItemSelectedHtml': '<span class="current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '{{itemTitle}}',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
    'paginateTopHtml': '{{previous}} <span class="pagination-count"></span> {{next}}',
  
    // Sorting Template
    'sortingHtml': '<select class="styled-select">{{sortingItems}}</select>',
};

BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {

    /*** Prepare data ***/
 // console.log('1');
//   console.log(data);
  
    var images = data.images_info;
  
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
//  console.log('on sale>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
//  console.log(data);
//  console.log(onSale);
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;
    // Add itemGridWidthClass
    var itemGridWidthClass = '';
    var productsPerRow = bcSfFilterConfig.custom.products_per_row;
    switch (productsPerRow) {
        case 6: itemGridWidthClass = buildItemGridClass('desktop-2', index, productsPerRow); break;
        case 4: itemGridWidthClass = buildItemGridClass('desktop-3', index, productsPerRow); break;
        case 3: itemGridWidthClass = buildItemGridClass('desktop-4', index, productsPerRow); break;
        case 5: itemGridWidthClass = buildItemGridClass('desktop-fifth', index, productsPerRow); break;
        case 2:  itemGridWidthClass = buildItemGridClass('desktop-6', index, productsPerRow); break;
        default: break;
    }
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

    // Add Label
    var itemNewLabelHtml = '';
    var itemSaleLabelHtml = '';
    var itemSoldoutLabelHtml = '';
    if (!soldOut) {
        for (var k in data.collections) {
            if (data['collections'][k]['handle'] == 'new') {
                itemNewLabelHtml = bcSfFilterTemplate.newLabelHtml;
                break;
            }
        }
        if (onSale) {

            var salepercentage = data.percent_sale_min+'% OFF';
            itemSaleLabelHtml = bcSfFilterTemplate.saleLabelHtml.replace(/SALE/g, salepercentage);
          //  itemSaleLabelHtml = bcSfFilterTemplate.saleLabelHtml.replace(/SALE/g, this.formatMoney(data.price_min, this.moneyFormat));
          
        }
    } else {
        itemSoldoutLabelHtml = bcSfFilterTemplate.soldOutLabelHtml;
    }
// Start Quick Size Add to Cart
var quicksizeelements = '';
for (var i = 0; i < data['variants'].length; i++) {
                if (data['variants'][i].available) {
                  if(data['variants'][i].inventory_policy == 'continue' && data['variants'][i].inventory_management == 'shopify' && data['variants'][i].inventory_quantity <= 0){
                  quicksizeelements += '<span data-sizeid="'+data['variants'][i]['id']+'" class="custom-add-size  available" >'+data['variants'][i]['title']+'<div class="continue-pre-sale"><div class="continue-pre-content">Pre Sale</div></div></span>';
                  }else{
                  quicksizeelements += '<span data-sizeid="'+data['variants'][i]['id']+'" class="custom-add-size else-pre-order-class available" >'+data['variants'][i]['title']+'<div class="continue-pre-sale"><div class="continue-pre-content">Pre Sale</div></div></span>';
                  }
                  
            }
            else{
                 quicksizeelements += '<span data-sizeid="'+data['variants'][i]['id']+'" class="custom-add-size soldout" >'+data['variants'][i]['title']+'</span>';
            }
        }
// End Quick Size Add to Cart 



    itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);
    itemHtml = itemHtml.replace(/{{itemSoldoutLabel}}/g, itemSoldoutLabelHtml);
    itemHtml = itemHtml.replace(/{{additemSize}}/g, quicksizeelements);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add price
    var itemPriceHtml = '';
    var currentCurrency = Shopify.currency.active.toLowerCase();
    var dataPriceMinVar = 'price_min_'+currentCurrency;
    var dataComparePriceMinVar = 'compare_at_price_min_'+currentCurrency;

    if(data[dataPriceMinVar]){
      data.price_min = data[dataPriceMinVar] * 100;
    }
    if(data[dataComparePriceMinVar]){
      data.compare_at_price_min = data[dataComparePriceMinVar] * 100;
    }
  
    if (onSale) {
        itemPriceHtml += '<div class="onsale">' + this.formatMoney(data.price_min, this.moneyFormat) + '</div>';
        itemPriceHtml += '<div class="was">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</div>';
    } else {
        itemPriceHtml += '<div class="prod-price">';
        if (priceVaries) {
            itemPriceHtml += bcSfFilterConfig.label.from_price + ' ' + this.formatMoney(data.price_min, this.moneyFormat) + ' - ' + this.formatMoney(data.price_max, this.moneyFormat);
        } else {
            itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
        }
        itemPriceHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Thumbnail & Flip Image
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '500x') : bcSfFilterConfig.general.no_image_url;
    var firstImageCLass = bcSfFilterConfig.custom.image_flip && images.length > 1 ? 'first-image' : '';
    var itemThumbHtml = '<img class="lazyload ' + firstImageCLass + '" data-src="' + itemThumbUrl + '" alt="{{itemTitle}}" data-original="' + itemThumbUrl + '" />';
    var itemFlipImageHtml = '';
    if (bcSfFilterConfig.custom.image_flip && images.length > 1) {
        itemFlipImageHtml = '<div class="hidden"><img class="lazyload" data-src="' + this.optimizeImage(images[1]['src'], '500x') + '" alt="{{itemTitle}}" /></div>';
    }
    itemHtml = itemHtml.replace(/{{itemThumb}}/g, itemThumbHtml);
    itemHtml = itemHtml.replace(/{{itemFlipImage}}/g, itemFlipImageHtml);

    // Add Quick view
    var itemQuickViewHtml = bcSfFilterConfig.custom.quick_view_enable ? bcSfFilterTemplate.quickViewHtml : '';
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    // Add Swatches
    var itemSwatchHtml = '';
    if (bcSfFilterConfig.custom.alternate_colors) {
        for (var k = 0; k < data.options_with_values.length; k++) {
            var option = data['options_with_values'][k]['name'];
            var option_handle = this.slugify(option);
            var option_index = k;

            var is_color = false;
            var downcased_option = option.toLowerCase();
            if (downcased_option.indexOf('color') > -1 || downcased_option.indexOf('colour') > -1) {
                itemSwatchHtml += '<div class="col-swatch">'                
                itemSwatchHtml += '<ul data-option-index="' + option_index + '" class="' + option_handle + ' options">';
                var values = '';
                var optionValues = data['options_with_values'][k]['values'];
                for (var i = 0; i < optionValues.length; i++) {
                    var value = optionValues[i]['title'];
                    var wrapped_value = ',' + value + ',';
                    if (values.indexOf(wrapped_value) == -1) {
                        var variantImage = bcSfFilterConfig.general.no_image_url;
                        if (optionValues[i]['image'] != null) {
                            var imageIndex = optionValues[i]['image'];
                            if (typeof (images[imageIndex]) !== 'undefined') {
                                variantImage = this.optimizeImage(images[imageIndex]['src']);
                            }
                        }
                        var fileColorUrl = bcSfFilterConfig.general.asset_url.replace('bc-sf-filter.js', this.slugify(value) + '.png');
                        itemSwatchHtml += '<li data-option-title="' + value + '" data-href="' + variantImage + '" class="color ' + this.slugify(value) + '">';
                        itemSwatchHtml += '<span style="background-color: ' + this.slugify(value.split(' ').pop()) + '; background-image: url(' + fileColorUrl + ')"></span>';
                        itemSwatchHtml == '</li>';
                        values += values + wrapped_value;
                    }
                }
                itemSwatchHtml += '</ul>';
                itemSwatchHtml += '</div>';
            }
        }
      
        if (bcSfFilterConfig.custom.image_flip == false) {
            itemSwatchHtml +=   '<script>' +
                                    "$('#product-listing-{{itemId}} .col-swatch li').each(function(){" +
                                        "var Original = $('#product-listing-{{itemId}} .prod-image img').attr('data-original'); " +
                                        "$(this).hover(function() {" +
                                            "var newImage = $(this).attr('data-href');" +         
                                            "$( '#product-listing-{{itemId}} .prod-image img' ).attr({ src: newImage }); " +
                                            "return false; " +         
                                        "}, function(){" +
                                            "$('#product-listing-{{itemId}} .prod-image img' ).attr({ src: Original }); " +
                                        "});" +
                                    "});" +
                                '</script>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);
  var currentDatecheck  = '';
  var limited = '';
  for(i=0;i<data.tags.length;i++){
    if(data.tags[i].indexOf('LIMITED') != -1){
    	limited = 'LIMITED EDITION';
    }
    if(data.tags[i].indexOf('-') != -1){
      var from = data.tags[i].split("-");
currentDatecheck = new Date(from[2], from[1] - 1, from[0]);
      
      
    }
  }

  	// Add loox reviews
    var looxHtml = '<div class="loox-rating" data-id="{{ product.id }}" data-rating="'+ bcsffilter.getProductMetafield(data, 'loox', 'avg_rating') + '" data-raters="' + bcsffilter.getProductMetafield(data, 'loox', 'num_reviews') +' "></div>'; 
    itemHtml = itemHtml.replace(/{{looxReviews}}/g, looxHtml);
    
    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemPriceNumber}}/g, this.formatMoney(data.price_min, this.moneyFormat));
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{limited}}/g, limited);
  itemHtml = itemHtml.replace(/{{createat}}/g, currentDatecheck);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{firstVariantId}}/g, firstVariant.id);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
  
}

function buildItemGridClass(itemClass, index, productsPerRow) {
 //  console.log('2');
    var temp = index < productsPerRow ? index : index % productsPerRow;
    if (temp == 1) { itemClass += ' first'; }
    else if (temp == 0) { itemClass += ' last'; };
    return itemClass;
}

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
 //  console.log('3');
    for (var k in data) {
        // Featured image
        if (data['images_info'] > 0) {
            data[k]['featured_image'] = data['images_info'][0];
        } else {
            data[k]['featured_image'] = {width: '', height: '', aspect_ratio: 0}
        }

        // Add Options
        var optionsArr = [];



        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
 
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;



        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
   console.log('4');
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        jQ('#bc-sf-filter-top-pagination').html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;
        var paginationTopHtml = bcSfFilterTemplate.paginateTopHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
        paginationTopHtml = paginationTopHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
        paginationTopHtml = paginationTopHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage in pageArr) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
        jQ('#bc-sf-filter-top-pagination').html(paginationTopHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
   console.log('6');
  if (typeof Ssw !== 'undefined' && typeof Ssw.loadBadges == 'function') { Ssw.loadBadges(); }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data) {
   console.log('7');
  setTimeout(function(){ 
    
    jQ('.create-at').each(function(){
      var current_date = new Date();
      var productdate = new Date(jQ(this).text());
      var newproddate = productdate;
      var thirtydays = new Date(jQ(this).text()).setDate(productdate.getDate() + 30); // add 30 days 
      if(current_date.getTime()>=newproddate.getTime() && current_date.getTime()<=thirtydays){
        
        jQ(this).parent().append('<div class="sale-item icn newprod">NEW</div>');
        
        
      }
    });
  }, 1500);
  setTimeout(function(){ 
    
    jQ('.limited-edition').each(function(){
      if(jQ(this).text() != ''){
        jQ(this).show();
      }
    });
  }, 1500);
    // Build Total Products
    var from = this.queryParams.page == 1 ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1;
    var to = from + data.products.length - 1;
    jQ('#pagination').find('.count').html(bcSfFilterConfig.label.showing_items + ' ' + from + '-' + to + ' ' +  bcSfFilterConfig.label.pagination_of + ' ' + data.total_product);

    // Build Top Pagination info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(data.total_product / this.queryParams.limit);
    jQ('#bc-sf-filter-top-pagination').find('.pagination-count').html(currentPage + ' ' + bcSfFilterConfig.label.pagination_of + ' ' + totalPage + ' ');

    var _this = this;
    jQ('#bc-sf-filter-top-pagination').find('a').on('click', function(e) {
        e.preventDefault();
        _this.internalClick = true;
        var newUrl = jQ(this).attr('href');
        _this.onChangeData(newUrl, 'page');
        jQ('body,html').animate({
            scrollTop: jQ(_this.selector.products).position().top
        }, 600);
    });
};
 
// Show Filter Tree on Mobile
BCSfFilter.prototype.buildFilterTreeMobileButtonEvent = function() {
  // console.log('8');
    var _this = this;
    jQ(this.selector.filterTreeMobileButton).on('click', function() {
        jQ('#sidebar').slideToggle();
        // Re-initialize jscrollpane
        _this.buildFilterScrollbar();
    });
}

function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];console.log('here updating');return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},console.log('here 239894872974'),BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */

